import { render, staticRenderFns } from "./ModalEligibilityCriteria.vue?vue&type=template&id=666471b4&scoped=true&"
import script from "./ModalEligibilityCriteria.vue?vue&type=script&lang=js&"
export * from "./ModalEligibilityCriteria.vue?vue&type=script&lang=js&"
import style0 from "./ModalEligibilityCriteria.vue?vue&type=style&index=0&id=666471b4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "666471b4",
  null
  
)

export default component.exports